import { motion } from 'framer-motion';

import { ActionInviteFriends } from './ActionInviteFriends';
import { ItemRanking } from './ItemRanking';

import { IconAtention } from '@/components/IconAtention';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { FCupParticipants } from '@/types/friendCup';
import { cn, FADE_IN_OUT, GENERICS_AMOUNTS, getParticipants } from '@/utils';

export const RankingTable = ({
  showInvite,
  team,
}: {
  showInvite: boolean;
  team: FCupParticipants[];
}) => {
  const { isDesktop } = useIsDesktop();

  if (!team) return;

  return (
    <div className="w-[calc(100%+2rem)] -left-4 relative lg:left-auto lg:w-auto">
      <div
        className={cn(
          'flex text-gdt-gray-4 font-semibold lg:font-bold text-2xs lg:text-sm h-10 mt-4 lg:mt-3 items-center px-4 lg:px-7  bg-gdt-gray-7 lg:bg-white',
          { 'rounded-lg': showInvite }
        )}
      >
        <p className="flex-1">DT</p>
        <p className="w-[60px] lg:w-[188px] text-center">
          {isDesktop ? (
            'Puntos Fecha'
          ) : (
            <span className="max-w-[30px] block mx-auto">Ptos. Fecha</span>
          )}
        </p>
        <p className="w-[88px] lg:w-[188px] text-center">
          {isDesktop ? 'Puntos acumulados' : 'Ptos. Acumulados'}
        </p>
      </div>
      {team && team.length !== 0 && (
        <motion.div animate={'show'} initial={'hide'} variants={FADE_IN_OUT}>
          <>
            <div className="lg:h-auto bg-white overflow-hidden rounded-lg">
              {team?.map((participant, index: number) => {
                return (
                  <ItemRanking
                    key={index + participant.idUsuario}
                    participant={participant}
                  />
                );
              })}
            </div>
            {showInvite && (
              <div className="flex flex-col items-center py-7 lg:pt-9 lg:pb-28 bg-white lg:rounded-lg">
                {isDesktop ? (
                  <p className="text-sm font-semibold text-gdt-status-red flex items-center space-x-2">
                    <IconAtention color="gdt-status.red.DEFAULT" />{' '}
                    <span>
                      {getParticipants(
                        team?.length || 0,
                        GENERICS_AMOUNTS.MAX_PLAYERS_FCUP
                      )}
                    </span>
                  </p>
                ) : (
                  <p className="text-sm text-gdt-gray-3 font-semibold">
                    {getParticipants(
                      team?.length || 0,
                      GENERICS_AMOUNTS.MAX_PLAYERS_FCUP
                    ).toUpperCase()}
                  </p>
                )}

                <ActionInviteFriends className="mt-2 lg:mt-4" />
              </div>
            )}
          </>
        </motion.div>
      )}
    </div>
  );
};
